let am = angular.module('ep-profile', []);

am.config(['$stateProvider', $stateProvider => {
  $stateProvider.
    state('profile', {
      url: '/profile',
      templateUrl: 'feature/profile/profile.html'
    });
}]);
